import React, { useState,useEffect } from "react";
// import history from "../../../../routes/history";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "./TalentEmployer.css";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import Logo from "../../../../assets/icons/SkillGigs_tm-black.svg";
// import talent from "../../../../assets/img/becomeACandidate.png";
import talent from "../../../../assets/img/Candidate.jpg";
// import employer from "../../../../assets/img/findACandidate.png"
import employer from "../../../../assets/img/Employer.jpg"
import {
  resetCompanyProfileDetails,
  updateCompanyProfileDetails,
  resetTalentProfileDetails,
} from "../../../../redux/actions";
import Loader from "../../../../components/Loading/Loader";
// import { getCookie } from "../../shared/helpers";

const TalentEmployer = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const loading = useSelector((state) => state.getCompanyDetailsReducer.loading);
  const success = useSelector((state) => state.getCompanyDetailsReducer.success);
  const [candidateCheck, setCandidateCheck] = useState(false);

  const talentEmpUpdate = (code, role) => {
    dispatch(
      updateCompanyProfileDetails({
        AccountTypeCode: code,
        Role: role,
        WizardFlow: code == "TAL" ? 1 : 0,
      })
    );
  };

  // Must be not be added with this Reducer

  useEffect(() => {
    if (success && !candidateCheck) {
      window.name = "employerprofession";
      dispatch(resetCompanyProfileDetails())      
      history.push('/employerprofession')
    }
    if (success && candidateCheck){
      window.name = "candidateprofession";      
      dispatch(resetTalentProfileDetails())   
      window.location.replace("/talent/auth")          
    }
  }, [success])

  return (
    <div className="TalentEmployerPage">
      {loading ? <Loader backgroundColor={"#f8f8f8"}/> :
        <div className="TalentEmployer">
          <div className="sectionTL">
            <div className="headerTL">
              {/* <div className="logoTL">
                <img src={Logo} alt="skillgigs_black_logo" />
              </div> */}
              <div className="subHeaderTL">
                <div className="Header">Welcome to <span><img src={Logo} alt="skillgigs_black_logo" /></span></div>
                
                <div>Let’s start by creating your profile </div>
                <div style={{marginTop: "7px"}} >Choose your role:</div> 
              </div>
            </div>
            <div className="chooseTalentorNot">
              <div
                className="becomeACandidateBOX"
                style={{cursor:"default"}}
              onClick={() => {
                  talentEmpUpdate("TAL"
                  // ["CONS"]
                  )
                  setCandidateCheck(true);
                }
              }
              >
                <img src={talent} alt="skillgigs_black_logo" loading="lazy" rel="preload"/>
                <div className="becomeACandidate">
                  <div className="title_div">
                    <div className="title">Candidate</div>
                    <div className="sub_title">Find your next dream gig</div>
                  </div>
                </div>
              </div>
              <div
                className="findACandidateBOX"
                onClick={() => {
                    talentEmpUpdate("EMP"
                    // ["CLIE"]
                    )
                  }
                }
              >
                <img src={employer} alt="skillgigs_black_logo" loading="lazy" rel="preload"/>
                <div className="findACandidate">
                  <div className="title_div">
                    <div className="title">Employer</div>
                    <div className="sub_title">Find the best candidates</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>
  );
};

export default TalentEmployer;
